// extracted by mini-css-extract-plugin
export default {"navSetting":"Products_navSetting__kQL4r","leftSetting":"Products_leftSetting__+IEDJ","select-input":"Products_select-input__s+7dg","form-control":"Products_form-control__JN4eA"};